import React, { useState } from 'react'
import axios from 'axios'
import { Navigate, useNavigate } from 'react-router-dom';

const ModalConfirm = ({ course, idCorse, setModalIsOpen, handleColse, request_register, getTrainingDaysMain }) => {
  const Url = `dashboard/member/request_register_${request_register}/${idCorse}/SELF`
  const Url1 = `dashboard/member/request_register_${request_register}/${idCorse}/MEMBER_FRIEND`
  // const navigate=useNavigate();
  // const [modalConfirmIsOpen, setModalConfirmIsOpen] = useState(false);
  // const [urlCardCom, seturlCardCom] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("כרטיס אשראי");
  const [agree, setAgree] = useState(false);
  const [isLoading, setIsLoading] = useState(false);




  const OverToPayMember = async () => {
    setIsLoading(true);
    await axios.post(`${Url1}`, {
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      if (response?.status == 200) {
        const data = response?.data;
        // setnamecalss("")
        // console.log(response)
        // seturlCardCom(response?.data?.urlPage)
        // setModalConfirmIsOpen(true)
        // getTrainingDays()
        // onNext(data)
        // onNext()
        // window.location.href =response?.data?.urlPage    
        alert(`Message: ${data}`);
        getTrainingDaysMain()
        handleColse()
      }
      else {
        alert(`שגיאה : ${response?.data?.message}`);
        //   onError(response.response?.data?.message)
        // console.log(response)
      }
    }).catch(error => {
      alert(`שגיאה : ${error?.response?.data?.message}`);
      //   onError(error?.response?.data?.message)

    })
  }
  const OverToPay = async () => {
    setIsLoading(true);
    // await axios.post(`${Url}`, {
    //         headers: { 'Content-Type': 'application/json' }
    //     }).then(response => {
    //         if (response?.status == 200) {
    //             // setnamecalss("")
    //             // console.log(response)
    //             // seturlCardCom(response?.data?.urlPage)
    //             // setModalConfirmIsOpen(true)
    //             console.log(response)
    //             // window.location.href =response?.data?.urlPage                   
    //             // window.location.href ="http://localhost:3000/registrationTrainingDays"                   
    //         }
    //     })


    try {
      await axios.post(`${Url}`, {
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {

        const data = response?.data;
        console.log(data)
        if (response?.status == 200) {
          if (typeof data === 'string') {
            //                         // אם התגובה היא הודעה (string)

            alert(`Message: ${data}`);
            getTrainingDaysMain()
            handleColse()
          }
          else {
            //                         // אם התגובה היא אובייקט (כמו SendProfileIdDto)
            // alert("Object:", data);
            // console.log(response.data)
            // if (response?.status == 200) {
            // setnamecalss("")
            // console.log(response)
            // seturlCardCom(response?.data?.urlPage)
            // setModalConfirmIsOpen(true)
            // console.log(response)
            window.location.href = response?.data?.urlPage
            // window.location.href ="http://localhost:3000/registrationTrainingDays"                   
          }
          // }
          //  else{
          //     console.log("שגיאה בבקשה:")
          //     // alert("שגיאה בבקשה:", data?.message)
        }
      })

    } catch (error) {
      console.log(error?.response?.data?.message)
      alert(`שגיאה : ${error?.response?.data?.message}`);
      // setErrMess(error?.response?.data?.message || "שגיאה בשליחת הנתונים");
      // await onError();
    }
  };

  return (
    <div className='absolute top-0  min-h-screen z-10 left-0 flex flex-col items-center pt-2 w-full  bg-[#FDFFFC]/50 '
      onClick={() => {
        // handleColse()
      }}>
      <div className='bg-white w-[40%]   rounded-lg   divide-y-2 divide-slate-500 border-0 drop-shadow-2xl shadow-2xl border-emerald-50 '>
        <div className='w-full bg-[#0d406b] rounded-t-md flex  border-[#0d406b] border-2'>
          <button className='p-1 px-2 m-3 border bg-slate-500 hover:bg-slate-200' onClick={() => {
            setModalIsOpen(false)
            //   
          }} >x</button>
        </div>


        <div className='p-2 text-center' >


          <div className="flex flex-col items-center p-2 gap-2 border rounded-2xl ">
            <p className="text-right w-full py-1">בחירת אמצעי תשלום:</p>
            <div className="payment-options">
              <label>
                <input
                  type="radio"
                  name="payment"
                  value="כרטיס אשראי"
                  checked={paymentMethod === "כרטיס אשראי"}
                  onChange={() => setPaymentMethod("כרטיס אשראי")}
                />
                כרטיס אשראי
              </label>
              <label>
                <input
                  type="radio"
                  name="payment"
                  value="לקוח משלם"
                  checked={paymentMethod === "לקוח משלם"}
                  onChange={() => {
                    setPaymentMethod("לקוח משלם")
                    setAgree(false)
                  }}
                />
                לקוח משלם
              </label>
            </div>

            {/* אישור תנאים */}
            {paymentMethod === "לקוח משלם" && <div className='text-red-500 text-sm font-medium p-2'>לחץ על הריבוע הריק לסימון V על מנת לאשר את ההצהרת ההשתפות ביום העיון
            </div>}
            {paymentMethod === "לקוח משלם" && <div className='grid grid-cols-4 ' >
              <label className='grid col-span-1 ml-2 text-sm  font-bold'>הצהרת השתתפות</label>
              <div className='grid col-span-3 '>
                <div className='flex'>
                  <input type="checkbox"
                    checked={agree}
                    onChange={() => setAgree(!agree)}></input>
                  <span className='px-2'>אני מצהיר כי ידועה לי חובת הנוכחות במשך יום העיון. כמו כן הובא לידיעתי כי אין להשתמש בטלפון סלולרי במהלך ההרצאות ביום הכשירות הפרונטלי. בנוסף הנני מתחייב שלא לבצע שימוש בטלפון הנייד בזמן נהיגה. ובנוסף קיימת חובת חתימה 3 פעמים כתנאי לקבלת אישור כשירות, באמצ</span>

                </div></div>
            </div>}
            {/* {paymentMethod==="לקוח משלם"&&<div className="terms " >
            <label className='w-56 ml-2 text-sm  font-bold'>הצהרת השתתפות</label>
            <input
              type="checkbox"
              checked={agree}
              onChange={() => setAgree(!agree)}
            />
            <p className="text-right">אני מצהיר כי ידועה לי חובת הנוכחות במשך יום העיון. כמו כן הובא לידיעתי כי אין להשתמש בטלפון סלולרי במהלך ההרצאות ביום הכשירות הפרונטלי. בנוסף הנני מתחייב שלא לבצע שימוש בטלפון הנייד בזמן נהיגה. ובנוסף קיימת חובת חתימה 3 פעמים כתנאי לקבלת אישור כשירות, באמצ

            </p> */}
            {/* <p className="text-right">
              אני מאשר כי אני מודע לתנאים ולהתחייבויות הקורס ולמדיניות האתר.
            </p> */}
            {/* </div>} */}
          </div>

        </div>
        <div className='flex justify-between text-white p-2'>
          <button className='bg-blue-900 text-xl p-2 rounded-md' onClick={() => { setModalIsOpen(false) }}>בטל</button>
          {/* <button className='bg-[#1e8e2b] text-xl p-2 rounded-md disabled:bg-slate-500' onClick={() => {
                        if(paymentMethod==="לקוח משלם")
                        {OverToPayMember()}
                        else{
                        OverToPay()}
                    }} disabled={paymentMethod==="לקוח משלם"&& !agree}>שלח</button> */}
          {paymentMethod === "לקוח משלם" && (
            <button className='bg-[#1e8e2b] text-xl p-2 rounded-md disabled:bg-slate-500' disabled={!agree || isLoading} onClick={OverToPayMember}>
              {isLoading ? <div className="spinner"></div> : "שלם"}
            </button>
          )}

          {paymentMethod === "כרטיס אשראי" && (
            <button className='bg-[#1e8e2b] text-xl p-2 rounded-md disabled:bg-slate-500' disabled={isLoading} onClick={OverToPay}>
              {isLoading ? <div className="spinner"></div> : "שלם"}
            </button>
          )}


        </div>
        {/* {modalConfirmIsOpen&&<iframe className='absolute h-screen' src={urlCardCom}></iframe>} */}
        {/* {modalConfirmIsOpen&&<navigate} */}
      </div>

    </div>
  )
}

export default ModalConfirm